import React from "react"
import { OutlineTitle } from "./styles"
import { Parallax } from "react-scroll-parallax"

const OutlineText = ({ children, color }) => {
  return (
    <Parallax
      x={[-5, 0]}
      styleOuter={{
        position: "absolute",
        bottom: 0,
        zIndex: 2,
      }}
    >
      <OutlineTitle color={color}>{children}</OutlineTitle>
    </Parallax>
  )
}

export { OutlineText }
